import { useContext } from "react";
import context from "@components/Auth/context";

export const useAuth = () => {
	const contextValue = useContext(context);
	if (!contextValue) {
		throw new Error("useAuth must be used within an AuthProvider");
	}
	return contextValue;
};
